import { render, staticRenderFns } from "./vehicledocuments.html?vue&type=template&id=3e443325&scoped=true&external"
import script from "./vehicledocuments.vue?vue&type=script&lang=js"
export * from "./vehicledocuments.vue?vue&type=script&lang=js"
import style0 from "./vehicledocuments.vue?vue&type=style&index=0&id=3e443325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e443325",
  null
  
)

export default component.exports